import PERMISSIONS from '../../../../constants/permissions';
import ROLES from '../../../../constants/roles';
import ROUTE from '../../../../constants/route';
import LinkBuilder from '../../../../helpers/link-builder';
import {hasRole, Permission} from '../../../../helpers/user';

export const ERRORS = {
  BECOME_CANDIDATE: 'become_candidate',
  ACCESS_LIMITS: 'access_limits',
  UPGRADE_RECRUITER_ACCOUNT: 'upgrade_recruiter_account',
  NO_ADD_REVIEW_RIGHT: 'no_add_review_right',
  PURCHASE_MORE_CREDITS: 'purchase_more_credits',
  MANAGE_EMAILS_TEMPLATES: 'manage_emails_templates',
};

export const CLICK_HANDLERS = {
  ADD_CANDIDATE_POSITION: 'add_candidate_position',
};

const permissionViewOwnProfile = {
  permission: PERMISSIONS.VIEW_OWN_PROFILE,
  reason: ERRORS.BECOME_CANDIDATE,
};

const Schema = [
  {
    name: 'Home',
    href: ROUTE.HOME,
    exact: true,
  },
  {
    name: 'Search',
    href: ROUTE.SEARCH,
    only: { role: ROLES.RECRUITER },
    children: [
      {
        name: 'Search',
        href: ROUTE.SEARCH,
      },
      {
        name: 'Post a Job',
        href: ROUTE.SEARCH_PROCESS_ADD,
        permissions: [
          {
            permission: PERMISSIONS.MANAGE_JOBS,
            reason: ERRORS.ACCESS_LIMITS,
          },
          {
            permission: PERMISSIONS.POST_JOB,
            reason: ERRORS.PURCHASE_MORE_CREDITS,
          },
        ],
      },
      {
        name: 'Manage Process',
        href: ROUTE.SEARCH_PROCESS_MANAGE,
        permissions: [
          {
            permission: PERMISSIONS.MANAGE_JOBS,
            reason: ERRORS.ACCESS_LIMITS,
          },
        ],
      },
      // {
      //   name: 'Post a Project',
      //   href: ROUTE.SEARCH_PROJECT_ADD,
      //   permissions: [
      //     {
      //       permission: PERMISSIONS.MANAGE_PROJECTS,
      //       reason: ERRORS.ACCESS_LIMITS,
      //     },
      //     {
      //       permission: PERMISSIONS.POST_PROJECT,
      //       reason: ERRORS.PURCHASE_MORE_CREDITS,
      //     },
      //   ],
      // },
      // {
      //   name: 'Manage Projects',
      //   href: ROUTE.SEARCH_PROJECT_MANAGE,
      //   permissions: [
      //     {
      //       permission: PERMISSIONS.MANAGE_PROJECTS,
      //       reason: ERRORS.ACCESS_LIMITS,
      //     },
      //   ],
      // },
      {
        name: 'Manage Emails Templates',
        href: ROUTE.SEARCH_EMAILS_TEMPLATES,
        permissions: [
          {
            permission: PERMISSIONS.USE_EMAIL_TEMPLATE_FOLLOWUP,
            reason: ERRORS.MANAGE_EMAILS_TEMPLATES,
          },
        ],
      },
      {
        name: 'Manage Firm Profile',
        href: null,
        only: {
          permission: PERMISSIONS.EDIT_FIRM_PROFILE,
        },
      },
      {
        name: 'My Shortlists',
        href: ROUTE.SEARCH_SHORTLIST,
        permissions: [
          {
            permission: PERMISSIONS.CANDIDATES_SHORTLISTS,
            reason: ERRORS.ACCESS_LIMITS,
          },
        ],
      },
      {
        name: 'Subscription Searches',
        href: ROUTE.SEARCH_SUBSCRIPTION,
        only: { role: ROLES.RECRUITER_GBS },
      },
      {
        name: 'My Team',
        href: ROUTE.SEARCH_TEAM,
        permissions: [
          {
            permission: PERMISSIONS.MY_TEAM,
            reason: ERRORS.ACCESS_LIMITS,
          },
        ],
      },
      {
        name: 'Rated Candidates',
        href: ROUTE.SEARCH_RATED,
        permissions: [
          {
            permission: PERMISSIONS.RATED,
            reason: ERRORS.UPGRADE_RECRUITER_ACCOUNT,
          },
        ],
      },
      {
        name: 'InBounds',
        href: ROUTE.SEARCH_INBOUNDS,
        permissions: [
          {
            permission: PERMISSIONS.INBOUNDS,
            reason: ERRORS.UPGRADE_RECRUITER_ACCOUNT,
          },
        ],
      },
    ],
  },
  {
    name: 'Jobs',
    href: ROUTE.JOBS,
    permissions: [permissionViewOwnProfile],
  },
  {
    name: 'Reviews',
    href: ROUTE.REVIEWS,
    activeRegExp: '/platform/firm/.+/(interview|employee|company|overview)+/.+',
    children: [
      {
        name: 'Reviews',
        href: ROUTE.REVIEWS,
      },
      {
        name: 'Add Company Review',
        href: ROUTE.ADD_REVIEW_COMPANY,
        permissions: [
          permissionViewOwnProfile,
          {
            permission: PERMISSIONS.ADD_OVERVIEW_REVIEW,
            reason: ERRORS.NO_ADD_REVIEW_RIGHT,
            type: 'company',
          },
        ],
      },
      {
        name: 'Add Interview Review',
        href: ROUTE.ADD_REVIEW_INTERVIEW,
        permissions: [
          permissionViewOwnProfile,
          {
            permission: PERMISSIONS.ADD_INTERVIEW_REVIEW,
            reason: ERRORS.NO_ADD_REVIEW_RIGHT,
            type: 'interview',
          },
        ],
      },
      {
        name: 'Add Employee Review',
        href: ROUTE.ADD_REVIEW_EMPLOYEE,
        permissions: [
          permissionViewOwnProfile,
          {
            permission: PERMISSIONS.ADD_EMPLOYEE_REVIEW,
            reason: ERRORS.NO_ADD_REVIEW_RIGHT,
            type: 'employee',
          },
        ],
      },
    ],
  },
  // {
  //   name: 'Projects',
  //   href: ROUTE.PROJECTS,
  //   permissions: [permissionViewOwnProfile],
  // },
  {
    name: 'Profile',
    activeRegExp: '/platform/candidate/([^inbox|mynetwork|people])(.*)',
    href: ROUTE.CANDIDATE_PROFILE,
    permissions: [permissionViewOwnProfile],
    children: [
      {
        name: 'Profile',
        href: ROUTE.CANDIDATE_PROFILE,
        permissions: [permissionViewOwnProfile],
      },
      {
        name: 'Add Position',
        onClickHandler: CLICK_HANDLERS.ADD_CANDIDATE_POSITION,
        permissions: [permissionViewOwnProfile],
      },
      {
        name: 'Confidential Information',
        href: ROUTE.CANDIDATE_CONFIDENTIAL,
        permissions: [permissionViewOwnProfile],
      },
      {
        name: 'Preparatory',
        href: ROUTE.CANDIDATE_PREPARATORY,
        permissions: [permissionViewOwnProfile],
      },
      {
        name: 'Aptitude',
        href: ROUTE.CANDIDATE_APTITUDE,
        permissions: [permissionViewOwnProfile],
      },
    ],
  },
  {
    name: 'Network',
    href: ROUTE.NETWORK,
    permissions: [permissionViewOwnProfile],
    children: [
      {
        name: 'Network',
        href: ROUTE.NETWORK,
        permissions: [permissionViewOwnProfile],
      },
      {
        name: 'My Network',
        href: ROUTE.MY_NETWORK,
        permissions: [permissionViewOwnProfile],
      },
      {
        name: 'People You May Know',
        href: ROUTE.PEOPLE_YOU_MAY_KNOW,
        permissions: [permissionViewOwnProfile],
      },
    ],
  },
  {
    name: 'Inbox',
    href: ROUTE.INBOX,
  },
];

const isDisallow = (user, permissions) =>
  permissions
    ? permissions.find(({ permission }) => {
        return !Permission.isAllowed(permission, user.permissions);
      })
    : false;

const isVisible = (user, item = {}) => {
  const isExcept = item.hasOwnProperty('except');

  const requirements = isExcept
    ? item.except
    : item.hasOwnProperty('only')
    ? item.only
    : null;
  if (!requirements) {
    return true;
  }

  const result = requirements.role
    ? hasRole(user.roles, requirements.role)
    : requirements.permission
    ? Permission.isAllowed(requirements.permission, user.permissions)
    : null;

  return result === null ? true : isExcept ? !result : result;
};

export const getMainMenuSchema = (user, pathname) =>
  Schema.map(item => {
    let isActive = item.activeRegExp
      ? new RegExp(item.activeRegExp).test(pathname) ||
        pathname.startsWith(item.href)
      : item.href === pathname;

    if (item.exact) {
      isActive = item.href === pathname;
    }

    return {
      ...item,
      visible: isVisible(user, item),
      disabled: isDisallow(user, item.permissions),
      isActive,
      children: item.children
        ? item.children.map(child => ({
            ...child,
            href:
              child.name === 'Manage Firm Profile'
                ? user.company
                  ? LinkBuilder.getFirmLink(user.company)
                  : ROUTE.ERROR_404
                : child.href,
            visible: isVisible(user, child),
            disabled: isDisallow(user, child.permissions),
          }))
        : null,
    };
  });

export default getMainMenuSchema;
